import logger from '../common/logger'
import GA4 from './ga4'

const AppLovinEventMappings = {
  'Landing Page': {
    eventName: 'page_view',
  },
  'Select Bundle': {
    eventName: 'view_item',
  },
  'Add to Cart': {
    eventName: 'add_to_cart',
  },
  'Start Checkout': {
    eventName: 'begin_checkout',
  },
  'Order Conversion': {
    eventName: 'purchase',
  },
}
const module = 'AppLovinTracker'
const AppLovinTracker = {
  pixelConfig: null,
  enabled: false,
  load: (pixelConfig) => {
    try {
      if (!pixelConfig || !pixelConfig?.axonKey) {
        return
      }
      AppLovinTracker.pixelConfig = pixelConfig
      AppLovinTracker.enabled = true
      /* eslint-disable */
      !(function (e, r) {
        var t = [
          'https://s.axon.ai/pixel.js',
          'https://c.albss.com/p/l/loader.iife.js',
        ]
        if (!e.axon) {
          var a = (e.axon = function () {
            a.performOperation
              ? a.performOperation.apply(a, arguments)
              : a.operationQueue.push(arguments)
          })
          ;(a.operationQueue = []),
            (a.ts = Date.now()),
            (a.eventKey = pixelConfig.axonKey)
          for (
            var n = r.getElementsByTagName('script')[0], o = 0;
            o < t.length;
            o++
          ) {
            var i = r.createElement('script')
            ;(i.async = !0), (i.src = t[o]), n.parentNode.insertBefore(i, n)
          }
        }
      })(window, document)

      window.axon('init')
      /* eslint-enable */
    } catch (e) {
      logger.error('load failed', e, { module })
    }
  },
  trackEvent: (eventProperties) => {
    try {
      if (!AppLovinTracker.enabled) {
        return
      }
      if (window.axon) {
        const eventName = eventProperties.eventName

        // Pass through the category ID
        eventProperties.propertyMeta = eventProperties.propertyMeta || {}
        eventProperties.propertyMeta.item_category_id =
          AppLovinTracker.pixelConfig.categoryId

        // AppLovin expects event data in the same format as GA4
        const eventMeta = GA4.buildGaEventProperties(eventProperties)
        if (AppLovinEventMappings?.[eventName]) {
          window.axon(
            'track',
            AppLovinEventMappings[eventName].eventName,
            eventMeta
          )
        }
      }
    } catch (e) {
      logger.error('trackEvent failed', e, { module })
    }
  },
}
export default AppLovinTracker
